import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const usePOPerms = () => {
  const { can, user } = useAuth();
  return { canEdit: (p) => !p.is_deleted && p.status !== "iptal" && can("satin_alma", "edit"), canDelete: (p) => !p.is_deleted && (user?.is_super || can("ithalat", "sil")) };
};

export default function POActions({ po, onEdit, onDelete, size = "icon" }) {
  const { canEdit, canDelete } = usePOPerms();
  const stop = (fn) => (e) => { e.stopPropagation(); fn(po); };
  return (
    <span className="inline-flex gap-1">
      {canEdit(po) && <Button size="sm" variant="ghost" className="h-7 px-2" onClick={stop(onEdit)} title="Düzenle" data-testid={`po-edit-${po.po_no}`}><Pencil className="h-3.5 w-3.5" />{size !== "icon" && <span className="ml-1">Düzenle</span>}</Button>}
      {canDelete(po) && <Button size="sm" variant="ghost" className="h-7 px-2 text-rose-600" onClick={stop(onDelete)} title="Sil" data-testid={`po-delete-${po.po_no}`}><Trash2 className="h-3.5 w-3.5" />{size !== "icon" && <span className="ml-1">Sil</span>}</Button>}
    </span>
  );
}
